import { FC, useEffect, useState } from "react";
import "./SidebarChatToolFilter.scss";
import SidebarFilter from "../../../../components/SidebarFilter/SidebarFilter";
import { useForm } from "react-hook-form";
import { Col, FormGroup, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import { customStyles } from "../../../../models/SelectCustomStyles";
import { useChatTools } from "../../../../providers/Chats/ChatToolsProvider";
import { useAgentsCategories } from "../../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider";
import { useSections } from "../../../../providers/Articles/Sections/SectionsProvider";

interface SidebarChatToolFilterProps {}

export const defaultValues = {
  name: "",
} as any;

const SidebarChatToolFilter: FC<SidebarChatToolFilterProps> = () => {
  const [selectedCategory, setSelectedCategory] = useState<any | null>(null);
  const [selectedSection, setSelectedSection] = useState<any | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<any | null>(null);

  const { handleSubmit, register } = useForm<any>({ defaultValues });

  const { setParams } = useChatTools();
  const { categoriesList, handleListCategories } = useAgentsCategories();
  const {
    sectionsOptions,
    setParams: setParamsSections,
    setSectionsOptions,
  } = useSections();

  useEffect(() => {
    handleListCategories();
  }, []);

  useEffect(() => {
    if (!!selectedCategory) {
      setParamsSections({
        withPaginate: false,
        filter: { category_id: selectedCategory?.value },
      });
    } else {
      setSelectedSection(null);
      setSectionsOptions([]);
    }
  }, [selectedCategory]);

  const categoriesOptions =
    categoriesList?.map((item: any) => ({
      label: item.name,
      value: item.id,
    })) ?? [];

  const statusOptions = [
    { label: "Todos", value: "" },
    { label: "Ativo", value: true },
    { label: "Inativo", value: false },
  ];

  const onSubmit = async (data: any) => {
    const filter: any = {
      name: data?.name || undefined,
      category_id: selectedCategory?.value ?? undefined,
      section_id: selectedSection?.value ?? undefined,
    };

    if (selectedStatus?.value === true) {
      filter.only_active = true;
    }

    setParams((prev: any) => ({
      ...prev,
      filter,
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  };

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div
        className="SidebarChatToolFilter"
        data-testid="SidebarChatToolFilter"
      >
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="name">NOME</label>
              <input className="form-control" {...register("name")} />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="category_id">CATEGORIA</label>
              <ReactSelect
                isSearchable
                isClearable
                options={categoriesOptions}
                value={selectedCategory}
                placeholder="Selecione"
                className="form-control p-0"
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => setSelectedCategory(e)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="section_id">SESSÃO</label>
              <ReactSelect
                isSearchable
                isClearable
                options={sectionsOptions ?? []}
                value={selectedSection}
                placeholder="Selecione"
                className="form-control p-0"
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => setSelectedSection(e)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="status">STATUS</label>
              <ReactSelect
                options={statusOptions}
                value={selectedStatus}
                placeholder="Selecione"
                className="form-control p-0"
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => setSelectedStatus(e)}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
};

export default SidebarChatToolFilter;